import axios from 'axios'

export default class IPService {

     getUserDataByApi(data) {
        return axios.get('https://ipapi.co/json/');
    }
}

